import React from "react";
import './MobileAddEditModal.scss'
import {ReactComponent as ArrowLeft} from "../../../assets/icons/squareArrowLeft.svg";
import {ReactComponent as CloseIcon} from "../../../assets/icons/squareCloseIcon.svg";

const MobileAddEditModal = props => {
    const {isPanelOpen, height, children, modalId, title, edit, closeMethod} = props;

    return (
        <div
            id={modalId}
            className={`MobileAddEditModal ${isPanelOpen ? 'open' : ''}`}
            style={height && {height: height}}
        >
            <div className="modalTitleContainer">
                <div className="modalTitle">
                    {title}
                </div>
                <div onClick={closeMethod} className="mobileIconContainer">
                    {edit ? <ArrowLeft /> : <CloseIcon />}
                </div>
            </div>
            {children}
        </div>
)
}

export default MobileAddEditModal
